import * as React from 'react';
import b_ from 'b_';
import { Dispatch } from 'redux';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { Link } from 'shared/components/Link';
import { actions } from 'shared/actions/app';
import { isAuthenticated } from 'shared/selectors/app';

import './indes.scss';

interface Props {
  fixedBottom?: boolean;
  isVisible?: boolean;
}

type Enhanced = Props &
  InjectedTranslateProps &
  ReturnType<typeof isAuthenticated> &
  ReturnType<typeof mapDispatchToProps>;

const mapDispatchToProps = (dispatch: Dispatch) => ({
  signup: () =>
    dispatch(actions.showAuthModal('signup', 'mainPage', 'desktopMainButtonRegistration')),
});

const enhance = compose<Enhanced, Props>(translate, connect(isAuthenticated, mapDispatchToProps));

const b = b_.with('main-page-detailed-login-btn');

const LoginButton: React.FC<Enhanced> = ({
  t,
  isAuthenticated,
  signup,
  isVisible,
  fixedBottom,
}) => {
  const wasLogin =
    typeof window !== 'undefined' &&
    window.localStorage &&
    window.localStorage.getItem('firstLoginAt');

  return (
    <>
      {isAuthenticated || wasLogin ? (
        <Link
          className={b({ 'fixed-bottom': fixedBottom, visible: isVisible })}
          to="/investments"
          data-gtm="mainpage-startinvesting-link"
          data-testid="startinvesting-button"
        >
          {t('Start investing')}
        </Link>
      ) : (
        <button
          className={b({ 'fixed-bottom': fixedBottom, visible: isVisible })}
          onClick={signup}
          data-gtm="mainpage-signup-btn"
          data-testid="startinvesting-button"
        >
          {t('Start investing')}
        </button>
      )}
    </>
  );
};

export default enhance(LoginButton);
